import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "21",
  fill: "none",
  viewBox: "0 0 22 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      d: "M15.125 2A5.5 5.5 0 0 0 11 3.916 5.5 5.5 0 0 0 6.875 2C4.05 2 1.833 4.218 1.833 7.042c0 3.465 3.117 6.288 7.838 10.578L11 18.82l1.329-1.21c4.72-4.28 7.837-7.103 7.837-10.568C20.166 4.218 17.948 2 15.125 2"
    }, null, -1)
  ])))
}
export default { render: render }